import { ReactElement, ReactNode } from 'react';
import { getclasses } from '../_helpers/dashboardHelper';
import { PriorityList } from '../constants/telosair-interfaces';

type StatusButtonProperties = {
  data: {
    property_name?: string;
    property_value: ReactNode;
    priority: PriorityList;
  };
};

/**
 * Getclasses function for getting the class for the component.
 * @param priority - Priority of the parameter.
 * @returns - String based on the priority of the parameter.
 */
const getCSSClassBasedOnPriority = (priority: PriorityList): string => {
  let classes = getclasses(false, priority);
  classes += ' hover:opacity-90';
  return classes;
};

/**
 * Renders a Status button Value component with a background color based on the priority.
 * @param props - Properties of the Status button Component.
 * @returns - A Status button component.
 */
export default function StatusButton(props: StatusButtonProperties): ReactElement {
  const { data } = props;

  if (data.property_value !== null) {
    return (
      <div
        className={`px-2 py-1.5 rounded text-sm font-semibold cursor-pointer text-gray-300 ${getCSSClassBasedOnPriority(
          data.priority
        )}`}
      >
        {data.property_value}
      </div>
    );
  }
  return (
    <div className="px-2 py-1.5 rounded text-sm font-semibold cursor-pointer text-gray-400 dark:text-gray-100 hover:bg-gray-500 hover:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-50">
      -
    </div>
  );
}
